import { BookText } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const DocumentationIcon = DeckardIconWrapper({ Icon: BookText });
